import React, { Component } from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button } from 'hljd'
import style from './index.module.less'
import store from '../../../store'

class Index extends Component {
  render() {
    return (
      <div className={style.sortBar}>
        <div className={style.srotTip}>
          <ExclamationCircleOutlined className={style.icon} />
          按点击率从高到低<span onClick={store.oneButtonSort}>一键排序</span>
        </div>
        <Button className={style.cancelBtn} onClick={store.sortCancle}>
          取消排序
        </Button>
        <Button
          type="primary"
          className={style.okBtn}
          onClick={store.saveCaseSort}
        >
          保存排序
        </Button>
      </div>
    )
  }
}

export default Index
